<template>
  <div>
    <save-consultant-basic-information-sidebar :callback="search" />
    <new-consultant-sidebar :callback="search" />
    <change-consultant-role-sidebar />
    <change-consultant-physical-franchise-sidebar />
    <digital-franchise-purchase-sidebar />
    <new-lead-sidebar />
    <div style="position: relative">
      <app-breadcrumb :breadcrumbTitle="false">
        <b-button
          v-if="canCreateEmployee && affiliationType != affiliationTypes.PN"
          variant="primary"
          @click="newConsultant()"
          style="position: absolute; right: 13; z-index: 1"
        >
          <feather-icon icon="PlusCircleIcon" class="mr-50" />
          <span class="text-nowrap"
            >Novo
            {{
              affiliationType == affiliationTypes.NETWORKER
                ? "networker"
                : "colaborador"
            }}</span
          >
        </b-button>
      </app-breadcrumb>
    </div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5 class="mb-1">Filtros</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="3">
            <b-form-group label="Nome" label-for="keyword" class="mt-1">
              <b-form-input
                id="keyword"
                v-model="keyword"
                @keyup.enter="search"
              />
            </b-form-group>
          </b-col>
          <template v-if="affiliationType == affiliationTypes.PN">
            <b-col cols="12" md="3">
              <b-form-group
                label="Escritórios"
                label-for="searchPhysicalFranchise"
                class="mt-1"
              >
                <v-select
                  id="searchPhysicalFranchise"
                  multiple
                  v-model="physicalFranchise"
                  :reduce="
                    (physical_franchise_list) => physical_franchise_list.id
                  "
                  :options="physicalFranchises"
                  :loading="loadingFilter.physicalFranchises"
                  label="name"
                  @keyup.enter="search"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                label="Franqueado"
                label-for="searchTeam"
                class="mt-1"
              >
                <v-select
                  id="searchFranchise"
                  multiple
                  v-model="franchise"
                  :reduce="(franchise_list) => franchise_list.id"
                  :options="franchises"
                  :loading="loadingFilter.franchises"
                  :close-on-select="false"
                  label="name"
                  @input="consultant = []"
                  @keyup.enter="search"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="Nível" label-for="searchTeam" class="mt-1">
                <v-select
                  id="searchRole"
                  multiple
                  v-model="role"
                  :reduce="(role_list) => role_list.id_consultant_role"
                  :options="roles"
                  :loading="loadingFilter.roles"
                  :close-on-select="false"
                  label="name"
                  @input="consultant = []"
                  @keyup.enter="search"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="Subnível" label-for="searchSubRole" class="mt-1">
                <v-select
                  id="searchSubRole"
                  multiple
                  v-model="subRole"
                  :reduce="(option) => option.id"
                  :options="subRoleOptions"
                  :loading="loadingFilter.subRoles"
                  :close-on-select="false"
                  label="name"
                  @keyup.enter="search"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </template>
          <b-col
            cols="12"
            md="3"
            v-if="affiliationType == affiliationTypes.EMPLOYEE"
          >
            <b-form-group
              label="Departamento"
              label-for="searchDepartment"
              class="mt-1"
            >
              <v-select
                id="searchDepartment"
                multiple
                v-model="department"
                :reduce="(department) => department.id"
                :options="departments"
                :loading="loadingFilter.departments"
                label="name"
                @keyup.enter="search"
              >
                <template #no-options="{ search, searching, loading }">
                  Sem resultados
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group label="Ativo" label-for="searchActive" class="mt-1">
              <v-select
                id="searchActive"
                v-model="active"
                :reduce="(options) => options.value"
                :options="assertOptions"
                label="name"
                @keyup.enter="search"
              >
                <template #no-options="{ search, searching, loading }">
                  Sem resultados
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3" v-if="affiliationType == affiliationTypes.PN">
            <b-form-group
              label="Data de aprovação"
              label-for="approvalDate"
              class="mt-1"
            >
              <v-select
                id="approvalDate"
                v-model="approvalDate"
                :reduce="(approvalDates) => approvalDates.approval_date"
                :options="approvalDates"
                label="approval_date_label"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group
              label="Data de criação"
              label-for="searchCreatedAt"
              class="mt-1"
            >
              <flat-pickr
                id="searchCreatedAt"
                v-model="createdAt"
                class="form-control"
                :config="flatPickrConfig"
                :placeholder="`01 Jan 2020 até 31 Dez ${actualYear}`"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3" v-if="affiliationType == affiliationTypes.PN">
            <b-form-group
              label="Data de envio da documentação"
              label-for="searchCompanyUpdateDate"
              class="mt-1"
            >
              <flat-pickr
                id="searchCompanyUpdateDate"
                v-model="companyUpdateDate"
                class="form-control"
                :config="flatPickrConfig"
                :placeholder="`01 Jan 2020 até 31 Dez ${actualYear}`"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group
              label="Data de desativação"
              label-for="searchDeletedAt"
              class="mt-1"
            >
              <flat-pickr
                id="searchDeletedAt"
                v-model="deletedAt"
                class="form-control"
                :config="flatPickrConfig"
                :placeholder="`01 Jan 2020 até 31 Dez ${actualYear}`"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3" v-if="affiliationType != affiliationTypes.PN">
            <b-form-group
              label="Tipo de contrato"
              label-for="searchContractType"
            >
              <v-select
                id="searchContractType"
                multiple
                v-model="userContractType"
                :reduce="(userContractTypes) => userContractTypes.id"
                :options="userContractTypes"
                label="name"
                @keyup.enter="search"
              >
                <template #no-options="{ search, searching, loading }">
                  Sem resultados
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mt-1 mb-md-0 mb-2 text-right">
            <b-button
              variant="outline-secondary"
              @click.prevent="clearSearch"
              :disabled="loading"
              v-text="'Limpar'"
            />
            &nbsp;
            <b-button
              variant="outline-primary"
              @click.prevent="search"
              :disabled="loading"
            >
              <b-spinner v-if="loading" small />
              <feather-icon v-else icon="SearchIcon" class="mr-50" />
              <span>
                {{ loading ? "Aguarde..." : "Pesquisar" }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mb-0">Exibir</label>
            <v-select
              v-model="itemsPerPage"
              dir="ltr"
              :options="itemsPerPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="search(currentPage)"
            >
              <template #no-options="{ search, searching, loading }">
                Sem resultados
              </template>
            </v-select>
            <label class="mb-0">itens</label>
          </b-col>
        </b-row>
      </div>
      <b-table
        hover
        :items="items"
        responsive
        :fields="tableColumns"
        primary-key="user_id"
        show-empty
        empty-text="Não foram encontrados itens para esta busca"
        :busy="loading"
        :no-local-sorting="true"
        :sort-by="sortField"
        @sort-changed="sort"
        @row-clicked="goToConsultantDetails"
      >
        <!-- Column: name -->
        <template #cell(name)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.name }}</span>
            <div v-if="data.item.is_inactive">
              <b-badge variant="warning">Inativo</b-badge>
            </div>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(email)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.email }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(role)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.role_name }}</span>
            <!-- Carreira em duas dimensões: atuação e, dentro dela, o subnível. -->
            <small
              v-if="careerLabel(data.item)"
              class="text-muted d-block"
            >{{ careerLabel(data.item) }}</small>
          </div>
        </template>
        <!-- Column: franqueado -->
        <template #cell(digital_franchise_name)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.digital_franchise_name }}</span>
          </div>
        </template>
        <!-- Column: escritório -->
        <template #cell(physical_franchise_name)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.physical_franchise_name }}</span>
          </div>
        </template>
        <!-- Column: origem -->
        <template #cell(lead_origin)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.lead_origin | leadOrigin
            }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(company_data_updated_at)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.company_data_updated_at | dateTime
            }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(created_at)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.created_at | dateTime
            }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(approval_date)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.approval_date | onlyDate
            }}</span>
          </div>
        </template>
        <template #cell(contract_type)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.contract_type | contractType
            }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(deleted_at)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{
              data.item.deleted_at | dateTime
            }}</span>
          </div>
        </template>
        <!-- Column: email -->
        <template #cell(contract_termination_signed_at)="data">
          <div class="text-wrap">
            <span
              v-if="data.item.contract_termination_signed_at"
              class="align-text-top"
            >
              {{ data.item.contract_termination_signed_at | dateTime }}
            </span>
            <span v-else class="align-text-top"> Não assinou </span>
          </div>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret right boundary="window">
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              @click="goToConsultantDetailsWithNewTab(data.item.id)"
            >
              <feather-icon icon="ExternalLinkIcon" />
              <span class="align-middle ml-50">Detalhes</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="updateConsultantEnabled  && 
                data.item.deleted_at == null"
              @click="editConsultant(data.item.id)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="affiliationType == affiliationTypes.NETWORKER && createLeadForNetworkerEnabled && !data.item.deleted_at"
              @click="createLeadForNetworker(data.item)"
            >
              <feather-icon icon="UserPlusIcon" />
              <span class="align-middle ml-50">Criar lead</span>
            </b-dropdown-item>
            <template v-if="affiliationType == affiliationTypes.PN">
              <b-dropdown-item
                v-if="requestCertificateEnabled"
                @click="goToRequestCertificate(data.item)"
              >
                <feather-icon icon="AwardIcon" />
                <span class="align-middle ml-50">Solicitar certificado</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="changeRoleEnabled && !data.item.deleted_at"
                @click="changeRole(data.item)"
              >
                <feather-icon icon="RepeatIcon" />
                <span class="align-middle ml-50">Alterar nível</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="changePhysicalFranchiseEnabled && !data.item.deleted_at"
                @click="changePhysicalFranchise(data.item)"
              >
                <feather-icon icon="HomeIcon" />
                <span class="align-middle ml-50">Alterar escritório</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canPurchaseFranchise(data.item.role_id) && !data.item.deleted_at"
                @click="purchaseFranchise(data.item)"
              >
                <feather-icon icon="DollarSignIcon" />
                <span class="align-middle ml-50">Comprar franquia</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="updateConsultantEnabled && !data.item.deleted_at"
                @click="verifyContractSignatureDate(data.item.id)"
              >
                <feather-icon icon="ZapIcon" />
                <span class="align-middle ml-50">Verificar contrato</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="updateConsultantEnabled"
                @click="verifyContractTerminationSignatureDate(data.item.id)"
              >
                <feather-icon icon="ZapOffIcon" />
                <span class="align-middle ml-50">Verificar distrato</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="updateConsultantEnabled && !data.item.deleted_at"
                @click="goToPnDnaCampaign(data.item)"
              >
                <feather-icon icon="SpeakerIcon" />
                <span class="align-middle ml-50">Campanha DNA Campeão 🎉</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="isSigned(data.item.contract_signed_at)"
                @click="downloadContrato(data.item.autentique_contract_id)"
              >
                <feather-icon icon="FileIcon" />
                <span class="align-middle ml-50">Baixar contrato</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="isSigned(data.item.contract_termination_signed_at)"
                @click="
                  downloadContrato(data.item.autentique_contract_termination_id)
                "
              >
                <feather-icon icon="FileIcon" />
                <span class="align-middle ml-50">Baixar distrato</span>
              </b-dropdown-item>
            </template>
            <b-dropdown-item
              v-if="canExtendDeadline && data.item.can_extend_deadline && isExtensionSafe(data.item)"
              @click="extend(data.item.user_id)"
            >
              <feather-icon icon="ClockIcon" />
              <span class="align-middle ml-50">Estender tempo de acesso</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-else-if="canExtendDeadline && data.item.can_extend_deadline"
              disabled
            >
              <feather-icon icon="ClockIcon" />
              <span class="align-middle ml-50">Estender tempo de acesso (disponível em {{ earliestExtensionDate(data.item) }})</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="deleteConsultantEnabled && !data.item.deleted_at"
              @click="deleteItem(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Desativar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Exibindo {{ pageItemsFrom }} à {{ pageItemsTo }} de
              {{ totalItems }} itens</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="itemsPerPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="search"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      v-model="terminationModal.visible"
      title="Motivo do desligamento"
      ok-title="Desativar"
      cancel-title="Cancelar"
      :ok-disabled="!terminationModal.reasonId || terminationModal.saving"
      :cancel-disabled="terminationModal.saving"
      no-close-on-backdrop
      @ok.prevent="confirmTermination"
      @hidden="resetTerminationModal"
    >
      <p class="mb-1">
        Para realizar o desligamento de um parceiro é necessário anexar um motivo.
      </p>
      <b-form-group label="Motivo do desligamento" label-for="terminationReason">
        <v-select
          id="terminationReason"
          v-model="terminationModal.reasonId"
          :reduce="reason => reason.id"
          :options="consultantTerminationReasons"
          :loading="terminationModal.loadingReasons"
          label="name"
          :clearable="false"
          :class="{ 'is-invalid': terminationModal.submitted && !terminationModal.reasonId }"
        >
          <template #option="reason">
            <div class="termination-reason-option">
              <strong>{{ reason.name }}</strong>
              <small class="text-muted">{{ reason.description }}</small>
            </div>
          </template>
          <template #selected-option="reason">
            <span :title="reason.description">{{ reason.name }}</span>
          </template>
          <template #no-options>
            Nenhum motivo encontrado
          </template>
        </v-select>
        <b-form-invalid-feedback :state="!(terminationModal.submitted && !terminationModal.reasonId)">
          Informe o motivo do desligamento.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-alert
        v-if="selectedTerminationReason"
        show
        variant="light-primary"
        class="termination-reason-description mb-1"
      >
        <strong>{{ selectedTerminationReason.name }}</strong>
        <p class="mb-0">
          {{ selectedTerminationReason.description }}
        </p>
      </b-alert>
      <b-form-group label="Detalhamento adicional" label-for="terminationDetails">
        <b-form-textarea
          id="terminationDetails"
          v-model="terminationModal.additionalDetails"
          rows="4"
          max-rows="8"
          placeholder="Contexto adicional opcional"
        />
      </b-form-group>
      <template #modal-ok>
        <b-spinner v-if="terminationModal.saving" small />
        <span>{{ terminationModal.saving ? "Aguarde..." : "Desativar" }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  BSpinner,
  BAlert,
  BFormGroup,
  BFormInvalidFeedback,
  BFormTextarea,
  BModal,
  BPopover,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  CREATE_ACTION,
  UPDATE_ACTION,
  DELETE_ACTION,
  EMPLOYEE,
  CONSULTANT_RESOURCE,
  READ_ACTION,
  CHANGE_CONSULTANT_ROLE,
  CHANGE_PHYSICAL_FRANCHISE,
  MANAGE_ACTION,
  DIGITAL_FRANCHISE_PURCHASE,
  EXTEND_CONSULTANT_DEADLINE,
  NETWORKER_LEAD_CREATION,
} from "@/constants/resources";
import * as leadTypes from "@/modules/lead/store/types";
import { LEAD_TYPE_PCL } from "@/constants/lead";
import UserDetailPopover from "@/modules/shared/components/UserDetailPopover";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr";
import todayButton from "@/helpers/todayButton";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";
import * as accountTypes from "@/modules/account/store/types";
import SaveConsultantBasicInformationSidebar from "@/modules/consultant/components/SaveConsultantBasicInformationSidebar";
import NewLeadSidebar from "@/modules/lead/components/NewLeadSidebar";
import NewConsultantSidebar from "@/modules/consultant/components/NewConsultantSidebar";
import ChangeConsultantRoleSidebar from "../components/ChangeConsultantRoleSidebar";
import ChangeConsultantPhysicalFranchiseSidebar from "../components/ChangeConsultantPhysicalFranchiseSidebar";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { getRangeDates } from "@/helpers/date_picker";
import { assertOptions } from "@/constants/assertions";
import useAppConfig from "@core/app-config/useAppConfig";
import AppBreadcrumb from "@core/layouts/components/AppBreadcrumb.vue";
import * as affiliationTypes from "@/constants/affiliation_types";
import * as consultantTypes from "@/constants/consultants";
import * as franchiseTypes from "@/modules/franchises/store/types";
import DigitalFranchisePurchaseSidebar from "../../franchises/components/DigitalFranchisePurchaseSidebar.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInvalidFeedback,
    BFormTextarea,
    BModal,
    BPopover,
    vSelect,
    flatPickr,
    UserDetailPopover,
    SaveConsultantBasicInformationSidebar,
    NewConsultantSidebar,
    ChangeConsultantRoleSidebar,
    ChangeConsultantPhysicalFranchiseSidebar,
    AppBreadcrumb,
    DigitalFranchisePurchaseSidebar,
    NewLeadSidebar,
  },
  setup() {
    const { skin } = useAppConfig();
    const actualYear = new Date().getFullYear();

    return { toast: useToast(), skin, actualYear };
  },
  props: {
    affiliationType: {
      type: String,
      default: affiliationTypes.PN,
    },
  },
  data() {
    return {
      affiliationTypes,
      loading: false,
      loadingFilter: {
        franchises: false,
        physicalFranchises: false,
        roles: false,
        subRoles: false,
        userContractTypes: false,
        departments: false,
      },
      flatPickrConfig: {
        altFormat: "j M Y",
        altInput: true,
        mode: "range",
        dateFormat: "Y-m-d",
        locale: Portuguese,
        plugins: [ShortcutButtonsPlugin(todayButton)],
      },
      assertOptions,
      currentPage: 1,
      itemsPerPage: 1,
      order: undefined,
      sortField: null,
      keyword: "",
      franchise: [],
      role: [],
      subRole: [],
      subRoles: [],
      active: undefined,
      approvalDate: undefined,
      createdAt: undefined,
      deletedAt: undefined,
      companyUpdateDate: undefined,
      physicalFranchise: [],
      userContractType: undefined,
      department: [],
      terminationModal: {
        visible: false,
        saving: false,
        loadingReasons: false,
        submitted: false,
        item: undefined,
        reasonId: undefined,
        additionalDetails: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      consultantsSearchResult: types.CONSULTANTS_SEARCH_RESULT,
      DnaHistoricalResult: types.DNA_HISTORICAL_SEARCH_RESULT,
      initialItemsPerPage: sharedTypes.INITIAL_ITEMS_PER_PAGE,
      itemsPerPageOptions: sharedTypes.ITEMS_PER_PAGE_OPTIONS,
      franchises: sharedTypes.FRANCHISES,
      roles: sharedTypes.ROLES,
      consultantApprovalDates: sharedTypes.CONSULTANT_APPROVAL_DATES,
      user: accountTypes.USER,
      userContractTypes: sharedTypes.USER_CONTRACT_TYPES,
      physicalFranchises: sharedTypes.PHYSICAL_FRANCHISES,
      departments: sharedTypes.DEPARTMENTS,
      consultantTerminationReasons: types.CONSULTANT_TERMINATION_REASONS,
    }),
    // O filtro guarda o id do subnível; o nome entra só como rótulo, prefixado pela atuação
    // porque o subnível só faz sentido dentro dela.
    // Só o nome da coluna "Label" da matriz, que já é único entre os 14 subníveis. O código do
    // nível de comissionamento vinha entre parênteses ("Hunter 1 (PNH 1)") e misturava as duas
    // coisas: quem filtra por subnível não está filtrando por nível de comissionamento, e para
    // sete deles o parêntese repetia o próprio nível ("Focado (FO)").
    subRoleOptions: function () {
      return this.subRoles.map((subRole) => ({
        id: subRole.id,
        name: subRole.commercial_label || subRole.label,
      }));
    },
    readConsultantEnabled: function () {
      return this.$can(READ_ACTION, CONSULTANT_RESOURCE);
    },
    createConsultantEnabled: function () {
      return this.$can(CREATE_ACTION, CONSULTANT_RESOURCE);
    },
    updateConsultantEnabled: function () {
      return this.$can(UPDATE_ACTION, CONSULTANT_RESOURCE);
    },
    canCreateEmployee: function () {
      return this.$can(CREATE_ACTION, EMPLOYEE);
    },
    requestCertificateEnabled() {
      return this.$can(READ_ACTION, CONSULTANT_RESOURCE);
    },
    approvalDates() {
      return _.map(this.consultantApprovalDates, (approvalDateObject) => ({
        approval_date: approvalDateObject.approval_date,
        approval_date_label: this.$options.filters.onlyDate(
          approvalDateObject.approval_date
        ),
      }));
    },
    deleteConsultantEnabled: function () {
      return this.$can(DELETE_ACTION, CONSULTANT_RESOURCE);
    },
    changeRoleEnabled: function () {
      return this.$can(CREATE_ACTION, CHANGE_CONSULTANT_ROLE);
    },
    changePhysicalFranchiseEnabled: function () {
      return this.$can(MANAGE_ACTION, CHANGE_PHYSICAL_FRANCHISE);
    },
    createLeadForNetworkerEnabled: function () {
      return this.$can(CREATE_ACTION, NETWORKER_LEAD_CREATION);
    },
    items: function () {
      return this.consultantsSearchResult?.data || [];
    },
    totalItems: function () {
      return this.consultantsSearchResult?.total || 0;
    },
    pageItemsFrom: function () {
      return this.consultantsSearchResult?.from || 0;
    },
    pageItemsTo: function () {
      return this.consultantsSearchResult?.to || 0;
    },
    selectedTerminationReason: function () {
      return _.find(this.consultantTerminationReasons, {
        id: this.terminationModal.reasonId,
      });
    },
    tableColumns: function () {
      var columns = [
        { key: "name", label: "Nome", stickyColumn: true },
        { key: "email", label: "E-mail", sortable: true },
        { key: "role", label: "Nível", sortable: true },
        { key: "digital_franchise_name", label: "Franqueado", sortable: true },
        { key: "physical_franchise_name", label: "Escritório", sortable: true },
        { key: "lead_origin", label: "Origem", sortable: true },
        {
          key: "company_data_updated_at",
          label: "Documentação enviada em",
          sortable: true,
        },
        { key: "created_at", label: "Criado em", sortable: true },
        { key: "approval_date", label: "Aprovado em", sortable: true },
        { key: "deleted_at", label: "Desativado em", sortable: true },
        {
          key: "contract_termination_signed_at",
          label: "Distrato",
          sortable: true,
        },
        { key: "actions", label: "Ações" },
      ];
      if (this.affiliationType != affiliationTypes.PN) {
        columns = _.filter(
          columns,
          (col) =>
            ![
              "role",
              "lead_goal",
              "lead_origin",
              "company_data_updated_at",
              "approval_date",
            ].includes(col.key)
        );
        if (this.affiliationType == affiliationTypes.EMPLOYEE) {
          columns.splice(
            2,
            0,
            { key: "department", label: "Departamento", sortable: true },
            { key: "contract_type", label: "Tipo de contrato", sortable: true }
          );
        } else if (this.affiliationType == affiliationTypes.NETWORKER) {
          columns.splice(2, 0, {
            key: "contract_type",
            label: "Tipo de contrato",
            sortable: true,
          });
        }
      }
      return columns;
    },
    canExtendDeadline: function(){
      return this.$can(MANAGE_ACTION, EXTEND_CONSULTANT_DEADLINE);
    },
  },
  watch: {
    affiliationType: function () {
      this.search();
      this.getContractTypes();
    },
  },
  mounted() {
    this.itemsPerPage = this.initialItemsPerPage;
    this.search();
    this.getConsultantApprovalDates();
    this.loadingFilter.franchises = true;
    this.getFranchises()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os franqueados para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilter.franchises = false;
      });
    this.loadingFilter.physicalFranchises = true;
    this.getRoles()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os niveis para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilter.physicalFranchises = false;
      });
    this.getPhysicalFranchises()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os escritórios para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilter.physicalFranchises = false;
      });
    this.loadingFilter.userContractTypes = true;
    this.getUserContractTypes(this.affiliationType)
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os tipos de contratos para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilter.userContractTypes = false;
      });
    this.loadingFilter.departments = true;
    this.getDepartments()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os departamentos para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loadingFilter.departments = false;
      });
    this.getContractTypes();
    this.loadTerminationReasons();
    this.loadSubRoleCatalog();
  },
  methods: {
    // A coluna já mostra o nível de comissionamento; embaixo vai o nome comercial do subnível,
    // e os dois juntos formam o par "Hunter 3 / PNH". Sem subnível ainda, mostra a atuação.
    careerLabel: function (consultant) {
      return consultant.sub_role_commercial_label || consultant.actuation_label || "";
    },
    loadSubRoleCatalog() {
      this.loadingFilter.subRoles = true;
      this.getSubRoleCatalog()
        .then((response) => {
          this.subRoles = response.data || [];
        })
        .catch(() => {
          this.subRoles = [];
        })
        .finally(() => {
          this.loadingFilter.subRoles = false;
        });
    },
    ...mapActions({
      searchConsultants: types.SEARCH_CONSULTANTS,
      getSubRoleCatalog: types.GET_SUB_ROLE_CATALOG,
      deleteConsultant: types.DELETE_CONSULTANT,
      openSaveConsultantBasicInformationSidebar:
        types.OPEN_NEW_CONSULTANT_SIDEBAR,
      openNewConsultantSidebar: types.OPEN_NEW_EMPLOYEE_SIDEBAR,
      updateContractSignatureDate:
        types.UPDATE_CONSULTANT_CONTRACT_SIGNATURE_DATE,
      updateContractTerminationSignatureDate:
        types.UPDATE_CONSULTANT_CONTRACT_TERMINATION_SIGNATURE_DATE,
      getFranchises: sharedTypes.GET_FRANCHISES,
      getRoles: sharedTypes.GET_ROLES,
      getConsultantApprovalDates: sharedTypes.GET_CONSULTANT_APPROVAL_DATES,
      openChangeConsultantRoleSidebar:
        types.OPEN_CHANGE_CONSULTANT_ROLE_SIDEBAR,
      openChangeConsultantPhysicalFranchiseSidebar:
        types.OPEN_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR,
      getPhysicalFranchises: sharedTypes.GET_PHYSICAL_FRANCHISES,
      downloadOnConsultants: types.DOWNLOAD_ON_CONSULTANTS,
      searcDnaHistory: types.GET_DNA_HISTORY,
      getUserContractTypes: sharedTypes.GET_USER_CONTRACT_TYPES,
      getDepartments: sharedTypes.GET_DEPARTMENTS,
      getConsultantTerminationReasons:
        types.GET_CONSULTANT_TERMINATION_REASONS,
      openDigitalFranchisePurchaseSidebar:
        franchiseTypes.OPEN_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR,
      extendDeadline: types.EXTEND_CONSULTANT_DEADLINE,
      openNewLeadSidebar: leadTypes.OPEN_NEW_LEAD_SIDEBAR,
    }),
    createLeadForNetworker(item) {
      this.openNewLeadSidebar({
        leadType: LEAD_TYPE_PCL,
        networkerConsultantId: item.id,
        saveAction: () => {},
      });
    },
    goToPnDnaCampaign(item) {
      this.$router.push({
        name: "consultant-dna-campaign",
        params: { id: item.id },
      });
    },
    canPurchaseFranchise(role_id){
      if(this.$can(CREATE_ACTION, DIGITAL_FRANCHISE_PURCHASE) && 
        !consultantTypes.isFeOrAboveConsultant(role_id)
      ){
        return true;
      }
      return false
    },
    editConsultant(consultant_id) {
      if (this.affiliationType == affiliationTypes.PN) {
        this.openSaveConsultantBasicInformationSidebar({
          id: consultant_id,
        });
      } else {
        this.openNewConsultantSidebar({
          id: consultant_id,
          affiliationType: this.affiliationType,
          saveAction: () => {
            this.search();
          },
        });
      }
    },
    newConsultant() {
      this.openNewConsultantSidebar({
        affiliationType: this.affiliationType,
        saveAction: () => {
          this.search();
        },
      });
    },
    verifyContractSignatureDate(consultant_id) {
      this.verifySignatureDate(
        this.updateContractSignatureDate,
        consultant_id,
        "contrato"
      );
    },
    verifyContractTerminationSignatureDate(consultant_id) {
      this.verifySignatureDate(
        this.updateContractTerminationSignatureDate,
        consultant_id,
        "distrato"
      );
    },
    verifySignatureDate(verify, consultant_id, document_type) {
      verify(consultant_id)
        .then((response) => {
          this.search();
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: `O ${document_type} foi atualizado`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: `Ocorreu um erro ao buscar ao verificar o ${document_type}. Entre em contato com o setor de TI.`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    purchaseFranchise(consultant){
      this.openDigitalFranchisePurchaseSidebar({
        consultant_id: consultant.id,
        saveAction: () => {
          this.search(this.currentPage);
        },
      });
    },
    search(currentPage = undefined) {
      this.loading = true;
      const {
        keyword,
        role,
        subRole,
        franchise,
        approvalDate,
        order,
        active,
        itemsPerPage,
        physicalFranchise,
        userContractType,
        department,
      } = this;
      const approvalDateFormatted = approvalDate
        ? new Date(approvalDate).toISOString().slice(0, 10)
        : undefined;
      const created = getRangeDates(this.createdAt);
      const deleted = getRangeDates(this.deletedAt);
      const companyUpdate = getRangeDates(this.companyUpdateDate);
      this.searchConsultants({
        keyword,
        franchise,
        physicalFranchise,
        userContractType,
        role,
        // O filtro de subnível só é exibido na aba de PNs. Sem este recorte ele continuaria
        // valendo, invisível, em Colaboradores e Networkers — que abririam vazios sem o usuário
        // ter como desfazer.
        subRole: this.affiliationType === affiliationTypes.PN ? subRole : [],
        order,
        active,
        approval_date: approvalDateFormatted,
        limit: itemsPerPage,
        affiliation: this.affiliationType,
        createdAtStart: created.start,
        createdAtEnd: created.end,
        deletedAtStart: deleted.start,
        deletedAtEnd: deleted.end,
        companyUpdateStart: companyUpdate.start,
        companyUpdateEnd: companyUpdate.end,
        department,
        currentPage: Number.isInteger(currentPage)
          ? currentPage
          : this.currentPage,
      })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao buscar os PNs. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteItem(item) {
      if (!item.deleted_at) {
        const type =
          this.affiliationType == affiliationTypes.PN
            ? "PN"
            : this.affiliationType == affiliationTypes.EMPLOYEE
            ? "Colaborador"
            : "Networker";

        if (this.affiliationType == affiliationTypes.PN) {
          this.openTerminationModal(item);
          return;
        }

        this.$swal({
          title: "Tem certeza?",
          text: `Você desativará o ${type} ${item.name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Desativar",
          cancelButtonText: "Cancelar",
          background: `${this.skin === "dark" ? "#283046" : ""}`,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary ml-1",
            htmlContainer: `${this.skin === "dark" ? "text-white" : ""}`,
          },
        }).then((result) => {
          if (result.value) {
            this.deleteConsultant(item.id)
              .then((response) => {
                this.search();
                this.toast({
                  component: ToastificationContent,
                  props: {
                    title: "Sucesso",
                    text:
                      `O ${type} ${item.name} foi desativado.` +
                      (this.affiliationType == affiliationTypes.PN
                        ? `Ele receberá via e-mail o distrato para assinatura.`
                        : ``),
                    icon: "CoffeeIcon",
                    variant: "success",
                  },
                });
              })
              .catch((error) => {
                this.toast({
                  component: ToastificationContent,
                  props: {
                    title: "Oops!",
                    text: error.response.data.message ?? `Ocorreu um erro ao desativar o ${type} ${item.name}. Entre em contato com o setor de TI.`,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      }
    },
    loadTerminationReasons() {
      if (!this.deleteConsultantEnabled) {
        return;
      }

      this.terminationModal.loadingReasons = true;
      this.getConsultantTerminationReasons()
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar os motivos de desligamento. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.terminationModal.loadingReasons = false;
        });
    },
    openTerminationModal(item) {
      this.terminationModal.item = item;
      this.terminationModal.visible = true;
    },
    resetTerminationModal() {
      if (this.terminationModal.saving) {
        return;
      }

      this.terminationModal = {
        ...this.terminationModal,
        visible: false,
        submitted: false,
        item: undefined,
        reasonId: undefined,
        additionalDetails: "",
      };
    },
    confirmTermination() {
      this.terminationModal.submitted = true;

      if (!this.terminationModal.reasonId || !this.terminationModal.item) {
        return;
      }

      const item = this.terminationModal.item;
      this.terminationModal.saving = true;
      this.deleteConsultant({
        id: item.id,
        termination_reason_id: this.terminationModal.reasonId,
        additional_details: this.terminationModal.additionalDetails,
      })
        .then(() => {
          this.terminationModal.saving = false;
          this.terminationModal.visible = false;
          this.search();
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: `O PN ${item.name} foi desativado. Ele recebera via e-mail o distrato para assinatura.`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: this.getTerminationErrorMessage(error),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.terminationModal.saving = false;
          if (!this.terminationModal.visible) {
            this.resetTerminationModal();
          }
        });
    },
    getTerminationErrorMessage(error) {
      return (
        error.response?.data?.message ??
        error.response?.data?.termination_reason_id?.[0] ??
        "Ocorreu um erro ao desativar o PN. Entre em contato com o setor de TI."
      );
    },
    clearSearch() {
      this.keyword = "";
      this.email = "";
      this.franchise = [];
      this.role = [];
      this.subRole = [];
      this.approvalDate = undefined;
      this.createdAt = undefined;
      this.deletedAt = undefined;
      this.companyUpdateDate = undefined;
      this.physicalFranchise = [];
      this.affiliation = undefined;
      this.search();
    },
    sort(event) {
      if (event.sortBy != "") {
        //clear in third click
        if (!event.sortDesc && this.sortField == event.sortBy) {
          this.order = undefined;
          this.sortField = null;
        } else {
          if (event.sortBy == "role") {
            event.sortBy = "role_name";
          }
          var direction = event.sortDesc ? " DESC" : " ASC";
          this.order = event.sortBy + direction;
          this.sortField = event.sortBy;
        }
        this.search();
      }
    },
    goToConsultantDetails(consultant, index) {
      this.$router.push({
        name: "consultant-details-summary",
        params: { id: consultant.id },
      });
    },
    goToEditConsultant(id) {
      this.$router.push({ name: "consultant-details-summary", params: { id } });
    },
    goToConsultantDetailsWithNewTab(id) {
      var routeData = this.$router.resolve({
        name: "consultant-details-summary",
        params: { id },
      });
      setTimeout(() => {
        window.open(routeData.href, "_blank");
      });
    },
    changeRole(consultant) {
      this.openChangeConsultantRoleSidebar({
        id: consultant.id,
        name: consultant.name,
        role: consultant.role_name,
        roleId: consultant.role_id,
        roleDepth: consultant.role_depth,
        contractType: consultant.user_contract_type_id,
        saveAction: () => {
          this.search(this.currentPage);
        },
      });
    },
    changePhysicalFranchise(consultant) {
      this.openChangeConsultantPhysicalFranchiseSidebar({
        id: consultant.id,
        name: consultant.name,
        physicalFranchiseId: consultant.physical_franchise_id,
        physicalFranchiseName: consultant.physical_franchise_name,
        saveAction: () => {
          this.search(this.currentPage);
        },
      });
    },
    isSigned(signed_at) {
      return !!signed_at;
    },
    downloadContrato(id) {
      this.loading = true;

      this.downloadOnConsultants({
        id: id,
      })
        .then((response) => {
          if (response.data.contract_url) {
            setTimeout(() => {
              window.open(response.data.contract_url, "_blank").focus();
            });
          } else {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao baixar o contrato. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao baixar o contrato. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getContractTypes() {
      this.loadingFilter.userContractTypes = true;
      this.getUserContractTypes(this.affiliationType)
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar os tipos de contratos para seleção. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loadingFilter.userContractTypes = false;
        });
    },
    goToRequestCertificate(consultant) {
      this.$router
        .push({
          name: "consultant-certificates",
          params: { id: consultant.id },
          query: { certificateModal: 1 },
        })
        .catch(() => {});
    },
    isExtensionSafe(item) {
      if (!item.personal_data_required_since) return false;
      // Extension only moves the deadline forward when personal_data_required_since
      // is already older than (contract_days - 7) days. With 30-day contracts: 23 days.
      const threshold = new Date(item.personal_data_required_since);
      threshold.setDate(threshold.getDate() + 23);
      return new Date() >= threshold;
    },
    earliestExtensionDate(item) {
      if (!item.personal_data_required_since) return '';
      const date = new Date(item.personal_data_required_since);
      date.setDate(date.getDate() + 23);
      return date.toLocaleDateString('pt-BR');
    },
    extend(user_id){
      this.extendDeadline({
        user_id
      })
      .then((response) => {
        var message = 'O tempo de acesso foi estendido'
        if(response.data.deadline_date){
          message += ` até ${response.data.deadline_date}.`
        } else {
          message += '.'
        }
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Sucesso",
            text: message,
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
        this.search(this.currentPage);
      }).catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: `Ocorreu um erro ao estender o tempo de acesso. Entre em contato com o setor de TI.`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.termination-reason-description {
  line-height: 1.45;

  strong {
    display: block;
    margin-bottom: 0.35rem;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.termination-reason-option {
  white-space: normal;
  line-height: 1.35;
  padding: 0.2rem 0;

  strong,
  small {
    display: block;
  }

  small {
    margin-top: 0.2rem;
  }
}
</style>
